import { ComboboxButton, Label } from "@headlessui/react-v2";

import { ChevronDownButton } from "./ChevronDownButton";
import { ClearButton } from "./ClearButton";
import { ComboboxComponent } from "./Combobox";
import { EmptyOption } from "./EmptyOption";
import { Input } from "./Input";
import { InputWrapper } from "./InputWrapper";
import { Option } from "./Option";
import { Options } from "./Options";
import { OptionsScrollableContainer } from "./OptionsScrollableContainer";

export const Combobox = Object.assign(ComboboxComponent, {
  ChevronDownButton,
  ClearButton,
  EmptyOption,
  Input,
  InputWrapper,
  Options,
  OptionsScrollableContainer,
  Option,
  Button: ComboboxButton,
  Label,
});
